<template>
  <div>
    <h1 style="overflow-wrap: break-word; hyphens: auto">{{ $t('labels.instructor-instruction') }}</h1>
    <template v-if="shouldReadInstructions">
      <MessageBox type="alert" class="my-5">
        <h6>ÄNDRINGAR</h6>
        <p>Handledarinstruktionerna har ändrats sedan du sist bekräftade dem. Dessa ändringar har gjorts:</p>
        <p>{{ instructions.commitMessage }}</p>
        <p class="font-weight-bold">Du behöver bekräfta handledarinstruktionerna på nytt.</p>
      </MessageBox>


      <ActionButton actionIcon="$sl-arrow-right" @click="$emit('nextStep')">Ditt ansvar som handledare</ActionButton>
    </template>
    <MessageBox class="my-5" type="info" v-else>
      <h6>REDAN BEKRÄFTADE</h6>
      <p>
        Du har redan bekräftat handledarinstruktionerna och behöver därför inte göra någonting just nu. Du kan alltid
        läsa instruktionerna för att påminna dig om dem.
      </p>

      <p><a href="https://www.byggbranschensyrkesnamnd.se/handledarinstruktioner/">https://www.byggbranschensyrkesnamnd.se/handledarinstruktioner/</a></p>
    </MessageBox>
  </div>
</template>

<script>
import MessageBox from '@/components/Common/MessageBox'
import ActionButton from '@/components/Common/ActionButton'

export default {
  name: 'InstructionsStart',

  mixins: [],

  props: {
    instructions: {
      type: Object,
      default: {}
    },
    shouldReadInstructions: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({}),

  components: {
    MessageBox,
    ActionButton
  }
}
</script>

<style scoped lang="scss"></style>
